import React from "react";

export const PageHeader = ({ eyebrow, title, subtitle, image }) => (
  <section className="relative h-[46vh] min-h-[360px] flex items-end overflow-hidden" data-testid="page-header">
    <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover opacity-55" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#070709] via-[#070709]/70 to-[#070709]/20" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-12 animate-fade-up">
      <p className="text-xs uppercase tracking-[0.3em] text-amber-400/90 font-semibold mb-4">{eyebrow}</p>
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white">{title}</h1>
      <p className="mt-4 text-slate-300 max-w-xl">{subtitle}</p>
    </div>
  </section>
);
